/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ExternalFileDto } from '../models/external-file-dto';
import { externalFilesDataSourceDataSourceIdGet$Json } from '../fn/external-files/external-files-data-source-data-source-id-get-json';
import { ExternalFilesDataSourceDataSourceIdGet$Json$Params } from '../fn/external-files/external-files-data-source-data-source-id-get-json';
import { externalFilesDataSourceDataSourceIdGet$Plain } from '../fn/external-files/external-files-data-source-data-source-id-get-plain';
import { ExternalFilesDataSourceDataSourceIdGet$Plain$Params } from '../fn/external-files/external-files-data-source-data-source-id-get-plain';
import { externalFilesExternalFileIdDelete } from '../fn/external-files/external-files-external-file-id-delete';
import { ExternalFilesExternalFileIdDelete$Params } from '../fn/external-files/external-files-external-file-id-delete';
import { externalFilesExternalFileIdGet$Json } from '../fn/external-files/external-files-external-file-id-get-json';
import { ExternalFilesExternalFileIdGet$Json$Params } from '../fn/external-files/external-files-external-file-id-get-json';
import { externalFilesExternalFileIdGet$Plain } from '../fn/external-files/external-files-external-file-id-get-plain';
import { ExternalFilesExternalFileIdGet$Plain$Params } from '../fn/external-files/external-files-external-file-id-get-plain';
import { externalFilesExternalFileIdSyncMetadataPost } from '../fn/external-files/external-files-external-file-id-sync-metadata-post';
import { ExternalFilesExternalFileIdSyncMetadataPost$Params } from '../fn/external-files/external-files-external-file-id-sync-metadata-post';
import { externalFilesRegisterRemotePost$Json } from '../fn/external-files/external-files-register-remote-post-json';
import { ExternalFilesRegisterRemotePost$Json$Params } from '../fn/external-files/external-files-register-remote-post-json';
import { externalFilesRegisterRemotePost$Plain } from '../fn/external-files/external-files-register-remote-post-plain';
import { ExternalFilesRegisterRemotePost$Plain$Params } from '../fn/external-files/external-files-register-remote-post-plain';
import { externalFilesUploadPost$Json } from '../fn/external-files/external-files-upload-post-json';
import { ExternalFilesUploadPost$Json$Params } from '../fn/external-files/external-files-upload-post-json';
import { externalFilesUploadPost$Plain } from '../fn/external-files/external-files-upload-post-plain';
import { ExternalFilesUploadPost$Plain$Params } from '../fn/external-files/external-files-upload-post-plain';

@Injectable({ providedIn: 'root' })
export class ExternalFilesApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `externalFilesUploadPost()` */
  static readonly ExternalFilesUploadPostPath = '/external-files/upload';

  /**
   * Upload external file.
   *
   * Uploads a file (CSV, XLSX, etc.) and registers it as a data source table.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `externalFilesUploadPost$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  externalFilesUploadPost$Plain$Response(params?: ExternalFilesUploadPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ExternalFileDto>> {
    const obs = externalFilesUploadPost$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Upload external file.
   *
   * Uploads a file (CSV, XLSX, etc.) and registers it as a data source table.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `externalFilesUploadPost$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  externalFilesUploadPost$Plain(params?: ExternalFilesUploadPost$Plain$Params, context?: HttpContext): Observable<ExternalFileDto> {
    const resp = this.externalFilesUploadPost$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ExternalFileDto>): ExternalFileDto => r.body)
    );
  }

  /**
   * Upload external file.
   *
   * Uploads a file (CSV, XLSX, etc.) and registers it as a data source table.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `externalFilesUploadPost$Json()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  externalFilesUploadPost$Json$Response(params?: ExternalFilesUploadPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ExternalFileDto>> {
    const obs = externalFilesUploadPost$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Upload external file.
   *
   * Uploads a file (CSV, XLSX, etc.) and registers it as a data source table.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `externalFilesUploadPost$Json$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  externalFilesUploadPost$Json(params?: ExternalFilesUploadPost$Json$Params, context?: HttpContext): Observable<ExternalFileDto> {
    const resp = this.externalFilesUploadPost$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ExternalFileDto>): ExternalFileDto => r.body)
    );
  }

  /** Path part for operation `externalFilesRegisterRemotePost()` */
  static readonly ExternalFilesRegisterRemotePostPath = '/external-files/register-remote';

  /**
   * Register remote file.
   *
   * Registers an existing remote file as an external file.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `externalFilesRegisterRemotePost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  externalFilesRegisterRemotePost$Plain$Response(params?: ExternalFilesRegisterRemotePost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ExternalFileDto>> {
    const obs = externalFilesRegisterRemotePost$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Register remote file.
   *
   * Registers an existing remote file as an external file.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `externalFilesRegisterRemotePost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  externalFilesRegisterRemotePost$Plain(params?: ExternalFilesRegisterRemotePost$Plain$Params, context?: HttpContext): Observable<ExternalFileDto> {
    const resp = this.externalFilesRegisterRemotePost$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ExternalFileDto>): ExternalFileDto => r.body)
    );
  }

  /**
   * Register remote file.
   *
   * Registers an existing remote file as an external file.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `externalFilesRegisterRemotePost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  externalFilesRegisterRemotePost$Json$Response(params?: ExternalFilesRegisterRemotePost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ExternalFileDto>> {
    const obs = externalFilesRegisterRemotePost$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Register remote file.
   *
   * Registers an existing remote file as an external file.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `externalFilesRegisterRemotePost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  externalFilesRegisterRemotePost$Json(params?: ExternalFilesRegisterRemotePost$Json$Params, context?: HttpContext): Observable<ExternalFileDto> {
    const resp = this.externalFilesRegisterRemotePost$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ExternalFileDto>): ExternalFileDto => r.body)
    );
  }

  /** Path part for operation `externalFilesExternalFileIdGet()` */
  static readonly ExternalFilesExternalFileIdGetPath = '/external-files/{externalFileId}';

  /**
   * Get external file.
   *
   * Returns metadata for an external file.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `externalFilesExternalFileIdGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  externalFilesExternalFileIdGet$Plain$Response(params: ExternalFilesExternalFileIdGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ExternalFileDto>> {
    const obs = externalFilesExternalFileIdGet$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get external file.
   *
   * Returns metadata for an external file.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `externalFilesExternalFileIdGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  externalFilesExternalFileIdGet$Plain(params: ExternalFilesExternalFileIdGet$Plain$Params, context?: HttpContext): Observable<ExternalFileDto> {
    const resp = this.externalFilesExternalFileIdGet$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ExternalFileDto>): ExternalFileDto => r.body)
    );
  }

  /**
   * Get external file.
   *
   * Returns metadata for an external file.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `externalFilesExternalFileIdGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  externalFilesExternalFileIdGet$Json$Response(params: ExternalFilesExternalFileIdGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ExternalFileDto>> {
    const obs = externalFilesExternalFileIdGet$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get external file.
   *
   * Returns metadata for an external file.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `externalFilesExternalFileIdGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  externalFilesExternalFileIdGet$Json(params: ExternalFilesExternalFileIdGet$Json$Params, context?: HttpContext): Observable<ExternalFileDto> {
    const resp = this.externalFilesExternalFileIdGet$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ExternalFileDto>): ExternalFileDto => r.body)
    );
  }

  /** Path part for operation `externalFilesExternalFileIdDelete()` */
  static readonly ExternalFilesExternalFileIdDeletePath = '/external-files/{externalFileId}';

  /**
   * Delete external file.
   *
   * Removes an external file registration and optionally its stored data.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `externalFilesExternalFileIdDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  externalFilesExternalFileIdDelete$Response(params: ExternalFilesExternalFileIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = externalFilesExternalFileIdDelete(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete external file.
   *
   * Removes an external file registration and optionally its stored data.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `externalFilesExternalFileIdDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  externalFilesExternalFileIdDelete(params: ExternalFilesExternalFileIdDelete$Params, context?: HttpContext): Observable<void> {
    const resp = this.externalFilesExternalFileIdDelete$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `externalFilesDataSourceDataSourceIdGet()` */
  static readonly ExternalFilesDataSourceDataSourceIdGetPath = '/external-files/data-source/{dataSourceId}';

  /**
   * List external files for data source.
   *
   * Lists all external files associated with a data source.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `externalFilesDataSourceDataSourceIdGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  externalFilesDataSourceDataSourceIdGet$Plain$Response(params: ExternalFilesDataSourceDataSourceIdGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ExternalFileDto>>> {
    const obs = externalFilesDataSourceDataSourceIdGet$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * List external files for data source.
   *
   * Lists all external files associated with a data source.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `externalFilesDataSourceDataSourceIdGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  externalFilesDataSourceDataSourceIdGet$Plain(params: ExternalFilesDataSourceDataSourceIdGet$Plain$Params, context?: HttpContext): Observable<Array<ExternalFileDto>> {
    const resp = this.externalFilesDataSourceDataSourceIdGet$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<ExternalFileDto>>): Array<ExternalFileDto> => r.body)
    );
  }

  /**
   * List external files for data source.
   *
   * Lists all external files associated with a data source.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `externalFilesDataSourceDataSourceIdGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  externalFilesDataSourceDataSourceIdGet$Json$Response(params: ExternalFilesDataSourceDataSourceIdGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ExternalFileDto>>> {
    const obs = externalFilesDataSourceDataSourceIdGet$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * List external files for data source.
   *
   * Lists all external files associated with a data source.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `externalFilesDataSourceDataSourceIdGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  externalFilesDataSourceDataSourceIdGet$Json(params: ExternalFilesDataSourceDataSourceIdGet$Json$Params, context?: HttpContext): Observable<Array<ExternalFileDto>> {
    const resp = this.externalFilesDataSourceDataSourceIdGet$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<ExternalFileDto>>): Array<ExternalFileDto> => r.body)
    );
  }

  /** Path part for operation `externalFilesExternalFileIdSyncMetadataPost()` */
  static readonly ExternalFilesExternalFileIdSyncMetadataPostPath = '/external-files/{externalFileId}/sync-metadata';

  /**
   * Sync external file metadata.
   *
   * Reads sheet/range metadata and updates TableMetadata and ColumnMetadata.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `externalFilesExternalFileIdSyncMetadataPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  externalFilesExternalFileIdSyncMetadataPost$Response(params: ExternalFilesExternalFileIdSyncMetadataPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = externalFilesExternalFileIdSyncMetadataPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Sync external file metadata.
   *
   * Reads sheet/range metadata and updates TableMetadata and ColumnMetadata.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `externalFilesExternalFileIdSyncMetadataPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  externalFilesExternalFileIdSyncMetadataPost(params: ExternalFilesExternalFileIdSyncMetadataPost$Params, context?: HttpContext): Observable<void> {
    const resp = this.externalFilesExternalFileIdSyncMetadataPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
